module.exports = __webpack_public_path__ + "c84f92d0254c14f1c8bfc24f3ecc9cff.svg";